import React, { useState } from "react";
import { UserEntity } from "../../../../application/domain/user/user-entity";
import { MessageDialog, WarningBanner } from "@graffer-inc/console-design-kit";
import { UserAuthMethod } from "../../../../application/domain/user/user";
import { ChangeAuthMethodToPasswordDialog } from "./auth-method-change-dialog-content/to-password";
import { ChangeAuthMethodToSAMLDialog } from "./auth-method-change-dialog-content/to-saml";

interface ModalWithInputProps {
  open: boolean;
  onCloseDialog: () => void;
  user: UserEntity;
  changeTo: UserAuthMethod | null;
}

type ChangeAuthMethodDialogError = {
  message: string;
  description: string;
};

const UnsupportedAuthMethodError: ChangeAuthMethodDialogError = {
  message: "このユーザーの認証方式を変更することはできません",
  description: "サポートされていない認証方式です",
};

const UserDoesNotHaveEmail: ChangeAuthMethodDialogError = {
  message: "このユーザーはパスワード認証に変更できません",
  description:
    "パスワード認証に切り替えるには、ユーザーにメールアドレスが登録されている必要があります。",
};

export const ChangeAuthMethodDialog: React.FC<ModalWithInputProps> = ({
  open,
  onCloseDialog,
  user,
  changeTo,
}) => {
  const [validationError, setValidationError] =
    useState<ChangeAuthMethodDialogError | null>(null);

  const isChangeableToPasswordAuthMethod = user.email !== "";

  React.useEffect(() => {
    clearError();

    switch (changeTo) {
      case "password":
        if (!isChangeableToPasswordAuthMethod) {
          setValidationError(UserDoesNotHaveEmail);
          break;
        }
        break;
      case "saml":
        // NOTE(morita): そもそも SAML 設定がなければこのダイアログは表示されないので、そのバリデーションはしていない
        break;
      default:
        setValidationError(UnsupportedAuthMethodError);
    }
  }, [changeTo]);

  const closeDialog = () => {
    clearError();
    onCloseDialog();
  };

  const clearError = () => {
    setValidationError(null);
  };

  const dialog = () => {
    switch (changeTo) {
      case "password":
        return (
          <ChangeAuthMethodToPasswordDialog
            user={user}
            onCloseDialog={onCloseDialog}
          />
        );
      case "saml":
        return (
          <ChangeAuthMethodToSAMLDialog
            user={user}
            onCloseDialog={onCloseDialog}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {open && (
        <>
          {validationError ? (
            <MessageDialog
              title="認証方式を変更できません"
              contents={
                <WarningBanner
                  message={validationError.message}
                  description={validationError.description}
                />
              }
              onCancel={closeDialog}
              cancelText="キャンセル"
            />
          ) : (
            dialog()
          )}
        </>
      )}
    </>
  );
};
